// extracted by mini-css-extract-plugin
export var author = "TeamMembers-module--author--UMZNp";
export var bio = "TeamMembers-module--bio--E1aW8";
export var container = "TeamMembers-module--container--KSoK9";
export var contentWrapper = "TeamMembers-module--content-wrapper--XJfib";
export var imageContainer = "TeamMembers-module--image-container--l7fgD";
export var reverse = "TeamMembers-module--reverse--BZq+I";
export var secondBio = "TeamMembers-module--second-bio--o30QB";
export var wrapper = "TeamMembers-module--wrapper--VucSe";
export var wrapperSecond = "TeamMembers-module--wrapper-second--g4njB";